import { z } from "zod";
import { createEndpoint, StandardSuccessResponseSchema } from "../createEndpoint";
import { HttpClient, QueryParams } from "../httpClient";
import {
    ExpertProfileSchema,
    UpdateExpertProfileRequest,
    ChangeExpertPasswordRequest,
    RequestExpertEmailChangeRequest,
    ExpertEmailChangeRequestResponseSchema,
    VerifyExpertEmailChangeRequest,
    ExpertVerifyEmailChangeResponseSchema,
} from "../schemas/expert-profile";

export function createExpertProfileApi(http: HttpClient, baseUrl: string) {
    const expertBaseUrl = `${baseUrl}/expert`;
    const securityBaseUrl = `${baseUrl}/expert/security`;

    return {
        getProfile: createEndpoint<
            z.infer<typeof ExpertProfileSchema>,
            unknown,
            QueryParams
        >(http, "GET", "/profile", {
            base: expertBaseUrl,
            responseSchema: ExpertProfileSchema,
        }),

        updateProfile: createEndpoint<
            z.infer<typeof ExpertProfileSchema>,
            UpdateExpertProfileRequest,
            QueryParams
        >(http, "POST", "/profile", {
            base: expertBaseUrl,
            responseSchema: ExpertProfileSchema,
        }),

        changePassword: createEndpoint<
            z.infer<typeof StandardSuccessResponseSchema>,
            ChangeExpertPasswordRequest,
            QueryParams
        >(http, "POST", "/change-password", {
            base: securityBaseUrl,
            responseSchema: StandardSuccessResponseSchema,
        }),

        requestEmailChange: createEndpoint<
            z.infer<typeof ExpertEmailChangeRequestResponseSchema>,
            RequestExpertEmailChangeRequest,
            QueryParams
        >(http, "POST", "/request-email-change", {
            base: securityBaseUrl,
            responseSchema: ExpertEmailChangeRequestResponseSchema,
        }),

        verifyEmailChange: createEndpoint<
            z.infer<typeof ExpertVerifyEmailChangeResponseSchema>,
            VerifyExpertEmailChangeRequest,
            QueryParams
        >(http, "POST", "/verify-email-change", {
            base: securityBaseUrl,
            responseSchema: ExpertVerifyEmailChangeResponseSchema,
        }),
    };
}

export type ExpertProfileApi = ReturnType<typeof createExpertProfileApi>;
